/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateExpenseItemRequest } from '../models/CreateExpenseItemRequest';
import type { ExpenseItemDto } from '../models/ExpenseItemDto';
import type { Page_ExpenseItemDto_ } from '../models/Page_ExpenseItemDto_';
import type { UpdateExpenseItemRequest } from '../models/UpdateExpenseItemRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ExpenseItemControllerService {
  /**
   * getAllExpenseItems
   * @returns Page_ExpenseItemDto_ OK
   * @throws ApiError
   */
  public static getAllExpenseItemsUsingGet({
    xTenantId,
    expenseCategoryId,
    limit = 10,
    offset,
    search,
    status,
  }: {
    /**
     * X-TENANT-ID
     */
    xTenantId: string;
    /**
     * expense-category-id
     */
    expenseCategoryId?: string;
    /**
     * limit
     */
    limit?: number;
    /**
     * offset
     */
    offset?: number;
    /**
     * search
     */
    search?: string;
    /**
     * status
     */
    status?: 'ACTIVE' | 'INACTIVE';
  }): CancelablePromise<Page_ExpenseItemDto_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/expense-items',
      headers: {
        'X-TENANT-ID': xTenantId,
      },
      query: {
        'expense-category-id': expenseCategoryId,
        limit: limit,
        offset: offset,
        search: search,
        status: status,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * createExpenseItem
   * @returns ExpenseItemDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static createExpenseItemUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: CreateExpenseItemRequest;
  }): CancelablePromise<ExpenseItemDto | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/expense-items',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getExpenseItem
   * @returns ExpenseItemDto OK
   * @throws ApiError
   */
  public static getExpenseItemUsingGet({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<ExpenseItemDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/expense-items/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * updateExpenseItem
   * @returns ExpenseItemDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static updateExpenseItemUsingPut({
    id,
    request,
  }: {
    /**
     * id
     */
    id: string;
    /**
     * request
     */
    request: UpdateExpenseItemRequest;
  }): CancelablePromise<ExpenseItemDto | any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/expense-items/{id}',
      path: {
        id: id,
      },
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * deleteExpenseItem
   * @returns ExpenseItemDto OK
   * @throws ApiError
   */
  public static deleteExpenseItemUsingDelete({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<ExpenseItemDto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/expense-items/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
}
